import autobind from 'autobind-decorator';
import * as React from 'react';

import { BillingPeriodUnit } from '../../enums/billing-period-unit';
import { SubscriptionAddon } from '../../interfaces/subscription-addon';
import { SubscriptionPlanVariantWithName } from '../../interfaces/subscription-plan-variant-with-name';
import { Styled } from './styled';
import { SubscriptionAddons } from './subscription-addons';
import { SubscriptionCustomOfferCard } from './subscription-custom-offer-card';
import { SubscriptionFeatures } from './subscription-features';
import { SubscriptionListingHead } from './subscription-listing-head';
import { SubscriptionOfferCard } from './subscription-offer-card';

interface Props {
  filteredPlanGroups: SubscriptionPlanVariantWithName[];
  filteredAddons: SubscriptionAddon[];
  selectedAddons: SubscriptionAddon[];
  selectedPlanGroup: string;
  billingPeriod: BillingPeriodUnit;
  selectedAddonGroups: string[];
  onSubscriptionPlanGroupClick: (groupName: string) => void;
  onSelectedAddonGroupsChanged: (selectedAddonGroups: string[]) => void;
  onBillingPeriodChanged: (billingPeriod: BillingPeriodUnit) => void;
}

export class SubscriptionListing extends React.Component<Props> {
  public render(): React.ReactNode {
    const filteredPlanGroupsWithoutPromo = this.props.filteredPlanGroups
      .filter(x => !x.name.toLowerCase().includes('sketchup'));

    return (
      <>
        <Styled.Offers planLength={filteredPlanGroupsWithoutPromo.length}>
          <SubscriptionListingHead
            billingPeriod={this.props.billingPeriod}
            setBillingPeriod={this.setBillingPeriod}
          />
          {this.getOffers()}
        </Styled.Offers>
        <SubscriptionFeatures planVariants={filteredPlanGroupsWithoutPromo} />
        <SubscriptionAddons
          addons={this.props.filteredAddons}
          selectedAddonGroups={this.props.selectedAddonGroups}
          subscriptionPlans={filteredPlanGroupsWithoutPromo}
          onSelectedAddonGroupsChange={this.onSelectedAddonGroupsChange}
        />
      </>
    );
  }

  @autobind
  private getOffers(): React.ReactNode {
    const { filteredPlanGroups, selectedAddons } = this.props;
    const filteredPlanGroupsWithoutPromo = filteredPlanGroups
      .filter(x => !x.name.toLowerCase().includes('sketchup'));

    return filteredPlanGroupsWithoutPromo.map((variant, index) => {
      return variant.isSelfService
        ? (
          <SubscriptionOfferCard
            key={variant.id}
            ghostButton={index === 0}
            onSelectPlanGroup={this.onSelectPlanGroup}
            variant={variant}
            selectedAddons={selectedAddons}
          />
        )
        : (
          <SubscriptionCustomOfferCard
            key={variant.id}
            variant={variant}
          />
        );
    });
  }

  @autobind
  private setBillingPeriod(billingPeriod: BillingPeriodUnit): void {
    this.props.onBillingPeriodChanged(billingPeriod);
  }

  @autobind
  private onSelectedAddonGroupsChange(selectedAddonGroups: string[]): void {
    this.props.onSelectedAddonGroupsChanged(selectedAddonGroups);
  }

  @autobind
  private onSelectPlanGroup(selectedPlanGroup: string): void {
    this.props.onSubscriptionPlanGroupClick(selectedPlanGroup);
  }
}
